module.exports = __webpack_public_path__ + "static/media/Nature Sounds - Seaside.f97fc3ea.mp3";